// extracted by mini-css-extract-plugin
export default {"root":"_1uCxj","collapsed":"_1hPy8"};